// Mock data for Dazzle Tech Landing Page

export const navigation = {
  brand: "Dazzle Tech",
  links: [
    { label: "How It Works", href: "#how-it-works" },
    { label: "Benefits", href: "#benefits" },
    { label: "Pro", href: "#pro" },
    { label: "Contact", href: "#contact" }
  ],
  ctaText: "Try the App",
  ctaUrl: "https://dazzle-tech.com/app/data-extract/app"
};

export const hero = {
  headline: "Extract Data from PDFs into Excel — Instantly",
  subheadline: "Upload your PDF documents and get clean, structured Excel files in seconds. No manual work required.",
  primaryCta: {
    text: "Try the App",
    url: "https://dazzle-tech.com/app/data-extract/app"
  },
  secondaryCta: {
    text: "See How It Works",
    href: "#how-it-works"
  }
};

export const howItWorks = {
  title: "How It Works",
  subtitle: "Three simple steps to transform your PDFs into structured Excel data",
  steps: [
    {
      number: "01",
      title: "Upload your PDF",
      description: "Drag and drop or select your PDF documents containing tables and data."
    },
    {
      number: "02",
      title: "Data is automatically extracted",
      description: "Our intelligent system analyzes and extracts structured data from your documents."
    },
    {
      number: "03",
      title: "Download the Excel file",
      description: "Get your clean, organized Excel spreadsheet ready for analysis and use."
    }
  ]
};

export const benefits = {
  title: "Key Benefits",
  subtitle: "Everything you need for efficient document data extraction",
  items: [
    {
      title: "No Manual Data Entry",
      description: "Eliminate tedious copy-paste work and reduce human errors."
    },
    {
      title: "Fast & Accurate Extraction",
      description: "Get precise results in seconds, not hours."
    },
    {
      title: "Free to Use",
      description: "Start extracting data immediately at no cost."
    },
    {
      title: "Works in Browser",
      description: "No software installation required. Use directly from any device."
    },
    {
      title: "Secure Document Handling",
      description: "Your files are processed securely and never stored."
    }
  ]
};

export const pro = {
  title: "Need More Power?",
  description: "The free version is perfect for basic usage. For higher limits, faster processing, and business needs, explore our Pro offering.",
  features: [
    "Complex documents including images",
    "Higher or unlimited document uploads",
    "Faster processing speeds",
    "Priority support",
    "Advanced extraction accuracy",
    "Bulk or custom processing"
  ],
  ctaText: "Get Pro / Contact Us",
  ctaHref: "#contact"
};

export const footer = {
  brand: "Dazzle Tech",
  description: "Building simple, powerful tools for automation.",
  links: [
    { label: "Try the App", url: "https://dazzle-tech.com/app/data-extract/app" },
    { label: "Contact", href: "#contact" }
  ],
  copyright: "© 2026 Dazzle Tech. All rights reserved."
};
